'use client'
import { FC, PropsWithChildren, useEffect } from 'react'
import { AvailableTheme, currentTranslations, getCurrentTranslations } from '@/lang'
import { IntlProvider } from 'react-intl'
import { rtlLocales } from '@/root/shared-consts'
import { Locale } from '@/root/shared-types'
import { useConfig, useCustomRouter } from '@/root/shared-hooks'

interface I18nProviderProps extends PropsWithChildren {
  locale?: Locale
}

const I18nProvider: FC<I18nProviderProps> = ({ children, locale: localeProp }) => {
  const { locale: routerLocale } = useCustomRouter()
  const locale = localeProp ?? routerLocale
  const { theme } = useConfig()
  const currentLocaleTranslations = getCurrentTranslations(theme as AvailableTheme)[
    locale as keyof typeof currentTranslations
  ]

  useEffect(() => {
    document.documentElement.lang = locale
    if (rtlLocales.includes(locale)) {
      document.documentElement.setAttribute('dir', 'rtl')
      return
    }
    document.documentElement.setAttribute('dir', 'ltr')
  }, [locale])

  return (
    <IntlProvider locale={locale} messages={currentLocaleTranslations}>
      {children}
    </IntlProvider>
  )
}

export default I18nProvider
